import { SVGInterface } from "../../interface";

const CaretDuoLeft = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.835 3.86998L13.055 2.09998L3.16504 12L13.065 21.9L14.835 20.13L6.70504 12L14.835 3.86998Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M20.835 3.86998L19.055 2.09998L9.16504 12L19.065 21.9L20.835 20.13L12.705 12L20.835 3.86998Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CaretDuoLeft;
